import { HubConnectionBuilder, HubConnection } from '@microsoft/signalr'
import { AuthClient } from "./ApiClientBase";
import * as api from "./ApiClient";
import { Store } from 'vuex';
import { isFeatureFlagEnabled } from '@/services/featureFlagService';

export function localizeToastMessageKey(
    notification: api.ToastNotification,
    localize: (key: string) => string,
): string {
    const messageKey = notification.messageKey;
    if (!messageKey) {
        return notification.message ?? '';
    }

    const localized = localize(messageKey);
    if (localized && localized !== messageKey) {
        return localized;
    }

    return notification.message ?? messageKey;
}

export class ToastNotificationsHandler {

    private context: Store<any>;
    private connection: HubConnection | null;

    constructor(context: Store<any>) {
        this.context = context;
        this.connection = null;
    }

    async start() {
        if (this.connection != null)
            return;

        var auth_client = AuthClient.getInstance();
        await auth_client.ensureToken();

        var client = new api.SignalRClient(auth_client);
        var data = await client.getSignalRConfig();
        this.connection = new HubConnectionBuilder()
            .withUrl(data.url!, { "accessTokenFactory": () => data.token! })
            .build();

        this.connection.on('ToastNotification', (messageReceived, data: string) => { this.HandleNotification(JSON.parse(data)) });
        this.connection.start();

        this.connection.onclose(() => { if (this.connection != null) this.connection.start() });
    }

    stop() {
        if (this.connection != null) {
            var con = this.connection;
            this.connection = null;
            con.stop();
        }
    }

    public async HandleNotification(notification: api.ToastNotification) {
        // TODO: remove if-block when NT-667-LocalizeToastNotificationMessageKey is fully rolled out
        if (await isFeatureFlagEnabled('NT-667-LocalizeToastNotificationMessageKey')) {
            const message = localizeToastMessageKey(
                notification,
                (key) => this.context.state.Localizer.Localize(key),
            );
            this.context.dispatch("ShowToast", new api.ToastNotification({
                message,
                type: notification.type,
                operationId: notification.operationId,
            }));
        } else {
            this.context.dispatch("ShowToast", notification);
        }
    }
}
